import { c as _c } from "react/compiler-runtime";
import { ButtonStyleType } from '@udemy-v2/react-core-components';
import { FormGroup, TextInputForm, TextInputProps } from '@udemy-v2/react-form-components';
import { Loader } from '@udemy-v2/react-reveal-components';
import classNames from 'classnames';
import React, { useRef, useEffect } from 'react';
import { useI18n } from '@udemy-v2/i18n';
import { MODES, ModesKeys } from './constants';
import styles from './coupon-form.module.scss';
interface CouponFormProps {
  onChange: (evt: React.ChangeEvent<HTMLInputElement>) => void;
  onSubmit: () => void;
  disabled?: boolean;
  error?: string;
  submittedCode: string;
  inputCode: string;
  currentMode: ModesKeys;
  isInCheckoutPane?: boolean;
  size?: TextInputProps['size'];
  submitButtonStyle?: ButtonStyleType;
}
export const CouponForm = t0 => {
  const $ = _c(44);
  const {
    onChange,
    onSubmit,
    disabled: t1,
    error,
    submittedCode,
    inputCode,
    currentMode,
    isInCheckoutPane: t2,
    size,
    submitButtonStyle
  } = t0;
  const disabled = t1 === undefined ? false : t1;
  const isInCheckoutPane = t2 === undefined ? false : t2;
  const {
    gettext
  } = useI18n();
  const inputRef = useRef(null);
  const t3 = disabled || currentMode === MODES.PENDING;
  let submitButtonContent;
  let submitButtonProps;
  if ($[0] !== currentMode || $[1] !== gettext || $[2] !== isInCheckoutPane || $[3] !== submitButtonStyle || $[4] !== t3) {
    submitButtonProps = {
      disabled: t3,
      udStyle: submitButtonStyle
    };
    let t4;
    if ($[7] !== gettext) {
      t4 = gettext("Apply");
      $[7] = gettext;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    submitButtonContent = t4;
    if (isInCheckoutPane) {
      submitButtonProps.udStyle = "secondary";
      submitButtonProps.className = currentMode === MODES.PENDING ? styles.submitButtonLoadingInCheckoutPane : undefined;
      let t5;
      if ($[9] !== currentMode || $[10] !== gettext) {
        t5 = currentMode === MODES.PENDING ? <Loader size="small" color="inherit" /> : gettext("Apply");
        $[9] = currentMode;
        $[10] = gettext;
        $[11] = t5;
      } else {
        t5 = $[11];
      }
      submitButtonContent = t5;
    }
    $[0] = currentMode;
    $[1] = gettext;
    $[2] = isInCheckoutPane;
    $[3] = submitButtonStyle;
    $[4] = t3;
    $[5] = submitButtonContent;
    $[6] = submitButtonProps;
  } else {
    submitButtonContent = $[5];
    submitButtonProps = $[6];
  }
  let t4;
  let t5;
  if ($[12] !== error) {
    t4 = () => {
      if (error && inputRef.current) {
        inputRef.current.focus();
      }
    };
    t5 = [error];
    $[12] = error;
    $[13] = t4;
    $[14] = t5;
  } else {
    t4 = $[13];
    t5 = $[14];
  }
  useEffect(t4, t5);
  let t6;
  if ($[15] !== onSubmit) {
    t6 = () => {
      onSubmit();
    };
    $[15] = onSubmit;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  const handleSubmit = t6;
  let t7;
  if ($[17] !== gettext) {
    t7 = gettext("Apply coupon");
    $[17] = gettext;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      className: "ud-sr-only"
    };
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  const t9 = submitButtonContent;
  let t10;
  if ($[20] !== error || $[21] !== gettext || $[22] !== submittedCode) {
    t10 = error ? submittedCode : gettext("Enter Coupon");
    $[20] = error;
    $[21] = gettext;
    $[22] = submittedCode;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  const t11 = size ?? (isInCheckoutPane ? "small" : "medium");
  const t12 = currentMode === MODES.PENDING || disabled;
  const t13 = error ? "coupon-error" : undefined;
  let t14;
  if ($[24] !== gettext) {
    t14 = gettext("Enter Coupon");
    $[24] = gettext;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  const t15 = !!error;
  let t16;
  if ($[26] !== handleSubmit || $[27] !== inputCode || $[28] !== onChange || $[29] !== submitButtonContent || $[30] !== submitButtonProps || $[31] !== t10 || $[32] !== t11 || $[33] !== t12 || $[34] !== t13 || $[35] !== t14 || $[36] !== t15) {
    t16 = <TextInputForm submitButtonContent={t9} onSubmit={handleSubmit} submitButtonProps={submitButtonProps} onChange={onChange} placeholder={t10} size={t11} value={inputCode} disabled={t12} data-purpose="coupon-input" aria-describedby={t13} aria-label={t14} aria-invalid={t15} ref={inputRef} />;
    $[26] = handleSubmit;
    $[27] = inputCode;
    $[28] = onChange;
    $[29] = submitButtonContent;
    $[30] = submitButtonProps;
    $[31] = t10;
    $[32] = t11;
    $[33] = t12;
    $[34] = t13;
    $[35] = t14;
    $[36] = t15;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  let t17;
  if ($[38] !== error) {
    t17 = error && <p id="coupon-error" data-purpose="coupon-form-error" className={classNames("ud-text-xs", styles["code-error"])} role="alert">{error}</p>;
    $[38] = error;
    $[39] = t17;
  } else {
    t17 = $[39];
  }
  let t18;
  if ($[40] !== t16 || $[41] !== t17 || $[42] !== t7) {
    t18 = <FormGroup label={t7} labelProps={t8} className={styles["coupon-form-group"]}>{t16}{t17}</FormGroup>;
    $[40] = t16;
    $[41] = t17;
    $[42] = t7;
    $[43] = t18;
  } else {
    t18 = $[43];
  }
  return t18;
};